import { useCallback, useEffect, useMemo, useState } from 'react';
import constate from '../../common/lib/constate';
import VideoService from '../service/VideoService';
import { useLanguageContext } from './LanguageContext';

const initialValue = {
  intro: {
    id: '',
    video: null,
    thumbnail: null,
    duration: null,
  },
  outro: {
    id: '',
    video: null,
    thumbnail: null,
    duration: null,
  },
};

function useIntroOutro() {
  const [isIntroOutroOpened, setIsIntroOutroOpened] = useState(false);
  const [introOutroConfig, setIntroOutroConfig] = useState([]);
  const [selectedIntroOutro, setSelectedIntroOutro] = useState(initialValue);

  const [videoOrientation, setVideoOrientation] = useState(null);

  const [introSwitch, setIntroSwitch] = useState(false);
  const [outroSwitch, setOutroSwitch] = useState(false);

  const [initialIntroOutro, setInitialIntroOutro] = useState(initialValue);

  const [isIntroOutroLoading, setIsIntroOutroLoading] = useState(true);

  const [blockPlayingIntroOutro, setBlockPlayingIntroOutro] = useState(false);

  const { language } = useLanguageContext();

  const resetContext = () => {
    setIntroSwitch(false);
    setOutroSwitch(false);
    setIntroOutroConfig([]);
    setSelectedIntroOutro(initialValue);
    setInitialIntroOutro(initialValue);
    setVideoOrientation(null);
    setIsIntroOutroLoading(true);
    setIsIntroOutroOpened(false);
  };

  const toggleIntroOutroOpened = useCallback(() => {
    setIsIntroOutroOpened(prevState => !prevState);
  }, []);

  const chooseIntroOutro = useCallback((introOutro) => {
    setSelectedIntroOutro(prevState => ({
      ...prevState,
      ...(introOutro?.hasOwnProperty('intro') ? { intro: introOutro.intro } : {}),
      ...(introOutro?.hasOwnProperty('outro') ? { outro: introOutro.outro } : {}),
    }));
  }, []);

  const changeInitialIntroOutro = useCallback(({ intro = null, outro = null }) => {
    setInitialIntroOutro({ intro, outro });
  }, []);

  useEffect(() => {
    const getIntroOutroConfig = async () => {
      try {
        // todo 777
        let { lng = 'en' } = language || {};

        if (lng === 'enGB') {
          lng = 'en';
        }

        const result = await VideoService.getIntroOutroConfig(videoOrientation, lng);
        setIntroOutroConfig(result.filter(item => !(item.intro === null && item.outro === null)));
      } catch (err) {
        console.log('err', err);
        setIntroOutroConfig([]);
      } finally {
        setIsIntroOutroLoading(false);
      }
    };

    if (videoOrientation) {
      getIntroOutroConfig();
    }
  }, [videoOrientation]);

  return useMemo(
    () => ({
      isIntroOutroOpened,
      toggleIntroOutroOpened,
      initialIntroOutro,
      changeInitialIntroOutro,
      selectedIntroOutro,
      chooseIntroOutro,
      introSwitch,
      outroSwitch,
      setIntroSwitch,
      setOutroSwitch,
      introOutroConfig,
      resetContext,
      setVideoOrientation,
      isIntroOutroLoading,
      blockPlayingIntroOutro,
      setBlockPlayingIntroOutro,
    }),
    [
      isIntroOutroOpened,
      toggleIntroOutroOpened,
      initialIntroOutro,
      changeInitialIntroOutro,
      selectedIntroOutro,
      chooseIntroOutro,
      introSwitch,
      outroSwitch,
      setIntroSwitch,
      setOutroSwitch,
      introOutroConfig,
      resetContext,
      setVideoOrientation,
      isIntroOutroLoading,
      blockPlayingIntroOutro,
      setBlockPlayingIntroOutro,
    ]
  );
}

export const useIntroOutroContext = constate(useIntroOutro);

const IntroOutroContext = {
  Provider: useIntroOutroContext.Provider,
};

export default IntroOutroContext;
